import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import {toArray, isObjectEmpty, buildUniqueArrayFromField} from '../../../Utils';
import {pipe, map, filter, sort, toTime, toTimeType} from '../../../Utils';

const ContainerComp = ({pageState}) =>{

    function getTableData(){    
        const {summaryData, classData, programs} = pageState;
        if(isObjectEmpty(summaryData)) return;
        
        let classIDList = buildUniqueArrayFromField(toArray(summaryData), 'classID');
        let classList = pipe(
            map(classID => classData[classID]),
            filter(classRec => classRec),
            sort((a,b) => (a.Classname.toUpperCase() > b.Classname.toUpperCase()) ? 1 : (a.Classname.toUpperCase() === b.Classname.toUpperCase() ? -1 : 0)),
        )(classIDList); 
                
        let programsPerClass = classIDList.map( classID => { return {classID,  // iterate all student ids         
            progs: summaryData.filter( summaryRec => // group all classes with the same id
                summaryRec.classID === classID).map(classRec => { return { // translate class array - prog array                    
                        title: programs[classRec.ProgID.toUpperCase()].title,
                        time: parseInt(classRec.CumulativeTime) + parseInt(classRec.CumulativeIdleTime),
                        correct: classRec.QuestionsRight + ' / ' + classRec.QuestionsAttempted,
                        percent: Math.round((parseInt(classRec.QuestionsRight)/parseInt(classRec.QuestionsAttempted))*100),
                        QuestionsRight: parseInt(classRec.QuestionsRight),
                        QuestionsAttempted: parseInt(classRec.QuestionsAttempted),
                        logins: 1
                    };
            }).reduce((acc, item) => { // merge dulicates
                let found = (acc.find(e => e.title === item.title));
                !found && acc.push(item);
                if(found){
                    found.QuestionsRight += item.QuestionsRight;
                    found.QuestionsAttempted += item.QuestionsAttempted;
                    found.time += item.time; 
                    found.correct = found.QuestionsRight + ' / ' + found.QuestionsAttempted;
                    found.percent = Math.round(found.QuestionsRight/found.QuestionsAttempted*100);
                    found.logins ++;
                }
                return acc;
            }
            ,[])
            };
        }).reduce((obj, item) => { // create a dictionary of classIDs and program lists
            obj[item.classID] = {progs:item.progs,
                combined: item.progs.reduce((acc, progRec)=>{
                    acc.QuestionsRight += progRec.QuestionsRight;
                    acc.QuestionsAttempted += progRec.QuestionsAttempted;
                    acc.time += progRec.time; 
                    acc.correct = acc.QuestionsRight + ' / ' + acc.QuestionsAttempted;
                    acc.percent = Math.round(acc.QuestionsRight/acc.QuestionsAttempted*100);
                    acc.logins += progRec.logins;
                    return acc;
                },{QuestionsRight:0, QuestionsAttempted:0, time: 0, correct:'no marks', percent:'no marks', logins:0})
            };
            return obj; 
        },{});                

        let classDataFiltered = toArray(classData).filter( classRec => // only care about students with marks
            classIDList.indexOf(classRec.ClassID) > -1
        );

        classDataFiltered = classDataFiltered.map( classRec => { 
            return {...classRec, programData: [...programsPerClass[classRec.ClassID].progs], combinedData: programsPerClass[classRec.ClassID].combined};
        });
        return classDataFiltered;   
    }
    
    return <><ProgramsClassesComp tableData={getTableData()} totals={pageState.schoolData}/></>;
};

Array.prototype.removeDuplicates = function(){
    return this.reduce((result,nextItem)=>
        result.includes(nextItem) ? result : result.concat(nextItem)
    ,[]);
};

const ProgramsClassesComp = ({tableData, totals}) => {
    const titleRow = <Row style={{fontWeight:'bold'}}>
        <Col  style={{textAlign: 'left'}} xs='4'>Students</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Logins</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Questions Correct</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Percent</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Time</Col>
    </Row>;

    return (
        <Container>
            {/* {totals.logins>1200 && <center style={{color:'red'}}>*** This summary might be incomplete, please try changing to a smaller date range ***</center>}   */}
            {titleRow}
            {tableData.map((ClassRec, stud_i) => <span key={stud_i}>
                <Row><Col xs='12' style={{fontWeight:'bold'}} >{ClassRec.Classname}</Col></Row>
                {ClassRec.programData.map((programRec, prog_i) => 
                    <ProgramRow key={prog_i} data={programRec} fontWeight={'normal'}/>
                )}
                <ProgramRow data={{name:'', logins: ClassRec.combinedData.logins, correct: ClassRec.combinedData.correct, percent:ClassRec.combinedData.percent, time:ClassRec.combinedData.time}} fontWeight={'bold'}/>
                </span>
            )}

            <Row><Col xs='12'></Col></Row>
            <ProgramRow data={{title: 'Total', logins: totals.logins, correct: totals.correct, percent:totals.percent, time:totals.time}} fontWeight={'bold'}/>

        </Container>
    );
};
ProgramsClassesComp.propTypes = {
    tableData: PropTypes.array
};

const ProgramRow = (props) => {
    const { title, logins, correct, percent, time} = props.data;

    return (
        <Row>
            <Col style={{textAlign: 'left', fontWeight: props.fontWeight}} xs='4'>{title}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{logins}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{correct}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{isNaN(percent)?'-':`${percent}%`}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{toTime(time)} {toTimeType(time)}</Col>
        </Row>
    );
};

ProgramRow.propTypes = {
    fontWeight: PropTypes.string,
    data: PropTypes.object
};

export default ContainerComp;
